export default __webpack_public_path__ + "static/media/illustration-phone-mockup.46990b53.svg";